import React from "react";
import { cn } from "@/lib/utils";

const STATUS = {
  connected: { label: "Connected", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  disconnected: { label: "Not connected", cls: "bg-surface-2 text-ink-muted border-edge-subtle" },
  needs_attention: { label: "Needs attention", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  error: { label: "Error", cls: "bg-red-50 text-red-700 border-red-200" },
  coming_soon: { label: "Coming soon", cls: "bg-surface-2 text-ink-muted border-edge-subtle" },
};

export function IntegrationStatusBadge({ status }) {
  const meta = STATUS[status] || STATUS.disconnected;
  return (
    <span
      className={cn(
        "inline-flex text-micro font-mono uppercase px-1.5 py-0.5 rounded border",
        meta.cls
      )}
    >
      {meta.label}
    </span>
  );
}

export function IntegrationCard({
  provider,
  icon,
  title,
  description,
  status,
  connectedAt,
  lastSyncAt,
  onAction,
  actionDisabled,
  actionLabel,
}) {
  const connected = status === "connected";
  const defaultLabel = connected
    ? "Manage"
    : status === "needs_attention" || status === "error"
      ? "Fix connection"
      : status === "coming_soon"
        ? null
        : "Connect";

  return (
    <article
      className="integration-card"
      data-testid={`integration-card-${provider || title}`}
    >
      <div className="integration-card__header">
        <div className="integration-card__icon">{icon}</div>
        <div className="min-w-0">
          <h3 className="text-stitle text-ink-primary truncate">{title}</h3>
          <IntegrationStatusBadge status={status} />
        </div>
      </div>
      <p className="text-compact text-ink-secondary mt-3 flex-1">{description}</p>
      <div className="integration-card__meta">
        {connectedAt && connected && (
          <span>Connected · {connectedAt}</span>
        )}
        {lastSyncAt && connected && (
          <span>Last synced {lastSyncAt}</span>
        )}
      </div>
      {defaultLabel && (
        <button
          type="button"
          className="mt-3 h-9 px-3 rounded-ctrl bg-signal-blue text-white text-compact disabled:opacity-50"
          onClick={onAction}
          disabled={actionDisabled || status === "coming_soon"}
        >
          {actionLabel || defaultLabel}
        </button>
      )}
    </article>
  );
}
